import { useCSVDownloader } from 'react-papaparse'
import { Button } from 'semantic-ui-react'

export default function CSVDownloader() {
  const { CSVDownloader: PapaDownloader } = useCSVDownloader()

  const TemplateDownloader = () => {
    const blankCSV = [
      {
        'Product Name': 'Product name 1',
        Brand: 'Brand 1',
        'Product Type': 'flower',
        'Brand Subtype': 'Brand Subtype 1',
        'Product Subtype': 'Gold',
        Lineage: 'indica',
        Amount: 'Amount 1',
        Dosage: 'Dose 1',
        'Net Weight g': '1',
        'CBD mg': '0',
        'THC mg': '0',
        'Quantity Value': '1',
        'Quantity Units': 'g',
        Description: 'Desc 1',
        Photo: 'a.jpg',
        Aliases: '1;2;3;4',
      },
      {
        'Product Name': 'Product name 2',
        Brand: 'Brand 2',
        'Product Type': 'flower',
        'Brand Subtype': 'Brand Subtype 2',
        'Product Subtype': 'Gold',
        Lineage: 'indica',
        Amount: 'Amount 2',
        Dosage: 'Dose 2',
        'Net Weight g': '2',
        'CBD mg': '1',
        'THC mg': '0',
        'Quantity Value': '2',
        'Quantity Units': 'g',
        Description: 'Desc 2',
        Photo: 'b.jpg',
        Aliases: '1;2;3;5',
      },
      {
        'Product Name': 'Product name 3',
        Brand: 'Brand 3',
        'Product Type': 'flower',
        'Brand Subtype': 'Brand Subtype 3',
        'Product Subtype': 'Gold',
        Lineage: 'indica',
        Amount: 'Amount 3',
        Dosage: 'Dose 3',
        'Net Weight g': '3',
        'CBD mg': '1',
        'THC mg': '0',
        'Quantity Value': '3',
        'Quantity Units': 'g',
        Description: 'Desc 3',
        Photo: 'c.jpg',
        Aliases: '1;2;3;6',
      },
      {
        'Product Name': 'Product name 4',
        Brand: 'Brand 4',
        'Product Type': 'flower',
        'Brand Subtype': 'Brand Subtype 4',
        'Product Subtype': 'Gold',
        Lineage: 'indica',
        Amount: 'Amount 4',
        Dosage: 'Dose 4',
        'Net Weight g': '4',
        'CBD mg': '1',
        'THC mg': '0',
        'Quantity Value': '4',
        'Quantity Units': 'g',
        Description: 'Desc 4',
        Photo: 'd.jpg',
        Aliases: '1;2;3;7',
      },
    ]

    return (
      <Button>
        <PapaDownloader filename="new-products-template" config={{ header: true }} data={blankCSV}>
          Download CSV template
        </PapaDownloader>
      </Button>
    )
  }

  return <TemplateDownloader />
}
